import { render, staticRenderFns } from "./encounters.vue?vue&type=template&id=41b597a1&"
import script from "./encounters.vue?vue&type=script&lang=js&"
export * from "./encounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports